var map = {
	"./OpexisLogo.png": 5531,
	"./PathrLogo.png": 5486,
	"./PulseLogo.jpg": 336,
	"./TypinLogo.png": 1689,
	"./algoPicksLogo.png": 4294,
	"./buddyLogo.png": 843,
	"./chessClockLogo.png": 4787,
	"./google.png": 565,
	"./humangptLogo.png": 59,
	"./pulseLogo.png": 7252,
	"./pulseLogo2.png": 636,
	"./runwayLogo.png": 581,
	"./scramdlebLogo.png": 2424,
	"./senttracLogo.png": 3461,
	"./silasFunLogo.png": 1794,
	"./theraiLogo.png": 5274,
	"./verifiLogo.png": 70,
	"./vscodeLogo.png": 2619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9514;